export default __webpack_public_path__ + "static/media/photo--sm--50.b18192cb.jpg";